<!-- <template>
  <div>


    <Sidebar />

    <Header />
    <main class="main-content">
      <router-view />
    </main>


    <Footer />

  </div>
</template>

<script>
import Sidebar from "@/components/layouts/Sidebar.vue";
import Footer from "@/components/layouts/Footer.vue";
import Header from "@/components/layouts/Header.vue";
export default {
  
  components: {
    Header,
    Sidebar,
    Footer
  }
}
</script> -->

<template>
  <div>

    <template v-if="!$route.meta.public">

      <Sidebar />

      <Header />
    </template>


    <main :class="$route.meta.public ? '' : 'main-content'">
      <router-view />
    </main>


    <Footer v-if="!$route.meta.public" />

  </div>
</template>

<script>
import Sidebar from "@/components/layouts/Sidebar.vue";
import Footer from "@/components/layouts/Footer.vue";
import Header from "@/components/layouts/Header.vue";
export default {
  
  components: {
    Header,
    Sidebar,
    Footer
  }
}
</script>



